import { useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { Logout } from '../Login/Logout';

interface INavProperties {
    minimal?: boolean;
    open?: boolean;
}

export function NavMenu({ minimal, open }: INavProperties) {
    const [collapsed, setCollapsed] = useState(!open);

    function toggleNavbar() {
        setCollapsed(c => !c);
    }
  
    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
                <NavbarBrand tag={Link} to="/">David.CommServer</NavbarBrand>
                {minimal ? undefined : (
                    <>
                        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/benutzer/list">Benutzer</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/partnerschaften/list">Partnerschaften</NavLink>
                                </NavItem>
                            </ul>
                        </Collapse>
                        <Logout />
                    </>
                )}
            </Navbar>
        </header>
    );
}
